import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, FloatingLabel, ListGroup } from 'react-bootstrap';
import "./VehicleCatalog.css";
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { FetchVariable } from '../../../src/Components/FetchVariable/FetchVariable'

function VehicleCatalog() {

  const [makeData, setMakeData] = useState([])
  const [modelData, setVehicleModelData] = useState([])
  const [catalogData, setCatalogData] = useState([])
  const [vehicleModelLength, setVehicleLength] = useState([1])
  const [pageQuery, setPageQuery] = useState("0");
  const totalPages = (Math.ceil(vehicleModelLength?.length / 12))
  const [trigger, setTrigger] = useState(false)

  useEffect(() => {
    fetch([`${FetchVariable.Heroku}/vehicle/all-vehicle-catalog/${pageQuery}`])
      .then(response => response.json())
      .then(data => {
        setCatalogData(data)
      })
      .catch(err => console.log(err));
  }, [pageQuery]);

  useEffect(() => {
    fetch([`${FetchVariable.Heroku}/vehicle/count-vehicle-for-sale`])
      .then(response => response.json())
      .then(forSaleLength => {

        setVehicleLength(forSaleLength)
      })
      .catch(err => console.log(err));
  }, []);
  

  useEffect(() => {
    fetch([`${FetchVariable.Heroku}/make`])
      .then(response => response.json())
      .then(makes => {
        setMakeData(makes);
      })
      .catch(err => console.log(err));
  }, []);


  function refreshPage() {
    window.location.reload(false);
  }

  const onVehicleMakeChange = MakeID => {

    const fetchModels = async () => {
      const modelsResponse = await fetch(`${FetchVariable.Heroku}/model/${MakeID}/model`)
      const models = await modelsResponse.json()
      setVehicleModelData(models)
      setPageQuery("0")
    }
    fetchModels()
  }

  const onVehicleModelChange = ModelID => {

    const fetchLength = async () => {
      const modelLengthResponse = await fetch(`${FetchVariable.Heroku}/vehicle/${ModelID}/vehicle-model-length/`)
      const modelLength = await modelLengthResponse.json()
      setVehicleLength(modelLength)
      const vehicleCatalogResponse = await fetch(`${FetchVariable.Heroku}/vehicle/${ModelID}/vehicle-catalog/${pageQuery}`)
      const vehicleCatalogData = await vehicleCatalogResponse.json()
      setCatalogData(vehicleCatalogData)
      setPageQuery("0")

      if(vehicleCatalogData.length === 0){
        setTrigger(true)
      }else{
        setTrigger(false)
      }
    }
    fetchLength()
  }

    //Pagination handleClick
  function handlePageClick(e) {
    setPageQuery(e.selected.toString())

  }


  const DisplayPagination = () => {
    if(trigger){
      return(
        <Row>
        <Col style={{color: "white", fontSize:"40px", text:"text-center" }}>No Vehicles for sale with this make and model.</Col>
        </Row>
      )
    }else{
      return (
      <Row>
      {catalogData?.map((catalog) => 
          <div className="card" key={catalog?.VehicleID} style={{width: '20rem'}}>
          <div className="imgWrapper">
          <img className="card-img-top carImg" src={catalog?.ImageURL} alt="Car"/>
          <img className="carImgLogo" src={`https://img.icons8.com/color/48/000000/${catalog?.Make?.toLowerCase()}.png`} 
                alt={catalog.Make} 
                style={{marginLeft: '0px'}}/>
          </div>
              <div className="card-body carCard">
                <h5 className="card-title carMake">{catalog?.Make}
                </h5>
                <ListGroup hortizontal="xl" variant="flush">
                  <ListGroup.Item variant="secondary" className="listGroup">{catalog.VehicleYear}</ListGroup.Item>
                  <ListGroup.Item variant="dark" >{catalog.Model} </ListGroup.Item>
                  <ListGroup.Item variant="dark" className="listGroup">Color {catalog.VehicleColor} </ListGroup.Item>
                  <ListGroup.Item variant="dark" className="listGroup2">{'$' + catalog.SalesPrice} </ListGroup.Item>
                </ListGroup>
                <Link to={{ 
                  pathname: `/vehicle-catalog/${catalog.VehicleID}`,
                  state: { VehicleID: catalog.VehicleID}
                }} className="btn detailsButton">
                View Details
                </Link>
              </div>
          </div>
          )}
    </Row>
      )
    }
  }

  return (
    <div className="vehicleCatalog">
        {/**BANNER */}
        <Container fluid="true" className="blurBack">
            <Row xs={1} md={2} fluid="true" className="searchCarHead">Search Vehicle for Sale</Row>
            <Col>
              <FloatingLabel className="searchMakeLabel" label="Choose your make">
                <Form.Select className="searchMake" aria-label="Select Make" onChange={e => onVehicleMakeChange(e.target.value)}>
                  <option className="makeOption">Make...</option>
                  {makeData?.map(Make => 
                  <option value={Make.MakeID} key={Make.MakeID}>{Make.Make}</option>)}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel className="searchMakeLabel" label="Choose your model">
                <Form.Select className="searchModel" aria-label="Select Model" onChange={e => onVehicleModelChange(e.target.value)}>
                  <option>Model...</option>
                  {modelData?.map(Model => 
                  <option value={Model.ModelID} key={Model.ModelID}>{Model.Model}</option>)}
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col>
                <button className="searchAllVehicle" variant="outline-dark" onClick={refreshPage}>Search All Vehicles for Sale</button>
            </Col>
          </Container>

            {/**SEARCH RESULTS CARS **/}
            <Container className="mx-auto">
            <Row>
            <h1 className="featuredCarsHeader">Searched Cars</h1>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={1}
                marginPagesDisplayed={1}
                pageCount={totalPages}
                forcePage={parseInt(pageQuery)}
                previousLabel="< previous"
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link_disable"}
                activeClassName={"pagination__link--active"}
            />
            </Row>
                  <DisplayPagination />
      </Container>
    </div>
  )
}
export default VehicleCatalog
